@if (showHideFooter) {
  <div class="footer text-base text-vis-subtle">
    <div class="flex flex-wrap container !px-v-spacing">
      <!-- Logo -->
      <div class="footer__logo-container w-full lg:w-1/2 pb-v-spacing lg:pb-0 flex flex-col md:flex-col justify-start md:justify-between lg:justify-start align-top">
        @for (footerLogo of footerLogos; track footerLogo) {
          <a
            class="hover:text-ace-teal-500"
            [href]="footerLogo.logoLink"
            aria-labelledby="logo-aceable-footer"
            >
            @if (footerLogo.logoImage.length > 0) {
              <img
                width="230"
                height="40"
                [src]="footerLogo.logoImage[0].url"
                [alt]="footerLogo.logoImage[0].altText ? footerLogo.logoImage[0].altText : ''"
                />
            }
            {{ footerLogo.logoImage.length === 0 ? stripLink(footerLogo.logoLink) : '' }}
            <span class="sr-only" id="logo-aceable-footer">Aceable</span>
          </a>
        }
        <!-- Aceable Family -->
        <div class="font-extrabold mt-6 mb-1 text-sm">
          <p>Part of the
            <a [attr.aria-labelledby]="'ace-footer-' + accessibilityService.getAriaLabelledby('Aceable') + '-nav-label'" class="text-vis-brand-1 underline font-bold" href="https://www.aceable.com/">
              <span>Aceable</span>
              <!-- Hidden Context -->
              <span [attr.id]="'ace-footer-' + accessibilityService.getAriaLabelledby('Aceable') + '-nav-label'" class="sr-only">{{accessibilityService.getCompleteTextContextForButton('https://www.aceable.com/', 'Aceable')}}</span>
            </a>
          Family</p>
        </div>
        <!-- Vertical Links: Driving, Real Estate, Insurance, Mortgage -->
        <div class="font-bold text-vis-brand-1 text-sm pb-v-spacing lg:pb-0">
          @for (link of verticalLinks; track link; let last = $last) {
            <a [attr.aria-labelledby]="'ace-footer-' + accessibilityService.getAriaLabelledby(link.linkText) + '-nav-label'" [href]="link.linkUrl" class="text-vis-brand-1 underline">
              <span>{{ link.linkText }}</span>
              <!-- Hidden Context -->
              <span [attr.id]="'ace-footer-' + accessibilityService.getAriaLabelledby(link.linkText) + '-nav-label'" class="sr-only">{{accessibilityService.getCompleteTextContextForButton(link.linkUrl, link.linkText)}}</span>
            </a>
            @if (!last) {
              <span class="mx-[10px] text-vis-subtle">|</span>
            }
          }
        </div>
        <!-- Refer and Partner Buttons -->
        @if (shareButtons) {
          <div class="flex flex-col sm:flex-row footer-buttons mt-6 sm:mt-8 md:mt-0 lg:mt-12">
            @for (b of shareButtons; track itemLabel($index, b); let last = $last) {
              <a
            class="
              footer-button
              text-ace-teal-800
              hover:text-vis-white
              active:text-vis-white
              hover:bg-ace-teal-800
              active:bg-ace-teal-950
              inline-flex
              cursor-pointer
              items-center
              justify-center
              py-3.5
              px-6
              w-fit
              border-[2px]
              border-solid
              border-ace-teal-800
              hover:border-ace-teal-800
              active:border-ace-teal-950
              rounded-[100px]
              {{ !last ? 'mb-2 sm:mb-0' : '' }}"
                href="{{b.link}}"
                [attr.aria-labelledby]="accessibilityService.getAriaLabelledby(b.label) + '-nav-label'"
                >
                <span class="label-primary" [innerHTML]="b.label"></span>
                <!-- Hidden Context -->
                <span [attr.id]="accessibilityService.getAriaLabelledby(b.label) + '-nav-label'" class="sr-only">{{accessibilityService.getCompleteTextContextForButton(b.link, b.label)}}</span>
              </a>
            }
          </div>
        }
      </div>
      <!-- General Links: Careers, Partnerships, Help Center, Contact, Our Blog -->
      <footer-link
        class="w-2/3 md:mt-1 pt-v-spacing lg:pt-0 lg:mt-0 mb-v-spacing md:w-1/3 lg:w-1/6"
        [links]="generalLinks"
        footerLocation="general"
        alignClass="md:items-end md:justify-end"
        linkClass="w-full lg:w-full"
      ></footer-link>
      <!-- Social Links: Twitter, Facebook, Instagram, LinkedIn, YouTube -->
      <footer-link
      class="
        md:pl-0
        lg:mt-0
        w-full
        md:w-1/3
        mx-0
        pt-v-spacing
        md:mt-1
        md:mb-v-spacing
        lg:py-0 lg:px-v-spacing lg:w-1/6
        py-3
        sm:px-v-spacing
      "
        [links]="socialLinks"
        footerLocation="social"
        alignClass="lg:items-start justify-between lg:justify-end w-full sm:w-3/4 md:w-full"
        linkClass=""
      ></footer-link>
      <!-- Copyright -->
      <div class="text-sm self-end lg:text-left footer__copyright py-1 w-full">
        <!-- Bottom Links: Privacy Policy, Terms & Conditions -->
        <div class="w-full flex flex-wrap flex-row items-baseline">
          <footer-link
            footerLocation="bottom"
            [links]="bottomLinks"
            alignClass="w-full"
            >
          </footer-link>
          <button class="hover:text-ace-teal-600 hover:underline" (click)="openPrivacyManagerModal()">Do Not Sell or Share My Personal Information</button>
        </div>
        <p class="pt-3 lg:pt-2">© {{ copyrightYear }} Aceable, Inc. <br class="hidden block sm:hidden">All rights reserved.</p>
      </div>
    </div>
  </div>
}
@if (emailCaptureData && !(promoBannerActive && ((!!graphicBanner) && displayRE))) {
  <email-capture [data]="emailCaptureData"></email-capture>
}

@if (showPrivacyManagerModal) {
  <privacy-manager (hideModal)="showPrivacyManagerModal = false;"></privacy-manager>
}
